export default __webpack_public_path__ + "static/media/php-negative.e1aa03ca.svg";